import api from '@/services/api'

const BASE_URL = '/objectives'
const today = new Date().toISOString().slice(0, 10)

const deleteObjective = async (objectiveId) => {
    try {
        return await api.delete(`${BASE_URL}/${objectiveId}`)
    } catch (error) {
        console.log(error)
    }
}

const getObjective = async (objectiveId) => {
    try {
        const response = await api.get(`${BASE_URL}/${objectiveId}`, {
            params: {
                with: 'period;section;tags;user;ancestors',
            },
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

const getAllObjectives = async () => {
    try {
        const response = await api.get(`${BASE_URL}`, {
            params: {
                search: `period.end_date:${today};`,
                searchFields: 'period.end_date:>=;',
                with: 'period;section;tags;user;ancestors',
            },
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

const searchByObjectivetName = async (search) => {
    try {
        const response = await api.get(`${BASE_URL}`, {
            params: {
                search: `title:${search};period.end_date:${today};`,
                searchFields: 'title:like;period.end_date:>=;',
                with: 'period;section;tags;user;ancestors',
                and: 'yes',
            },
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

const putObjective = async (objectiveId, payload) => {
    try {
        const response = await api.put(`${BASE_URL}/${objectiveId}`, payload)
        return response.data
    } catch (error) {
        console.log(error)
    }
}

const getKeyResultsOfObject = async (objectiveId) => {
    try {
        const response = await api.get(`${BASE_URL}/${objectiveId}/keyresults`)
        return response.data
    } catch (error) {
        console.log(error)
    }
}

const createObjective = async (data) => {
    const { description, level, period_id, section_id, tags, title, user_id } = data
    const objective = {
        description,
        level,
        period_id,
        section_id,
        title,
        user_id,
        tags_ids: tags.map((tag) => tag.id),
    }
    try {
        const response = await api.post(`${BASE_URL}`, objective)
        return response.data
    } catch (error) {
        console.log(error)
    }
}

const createKeyResult = async (objectiveId, data) => {
    try {
        const response = await api.post(`${BASE_URL}/${objectiveId}/keyresults`, data)
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export {
    deleteObjective,
    getObjective,
    getAllObjectives,
    searchByObjectivetName,
    putObjective,
    getKeyResultsOfObject,
    createObjective,
    createKeyResult,
}
